import { render, staticRenderFns } from "./Exercises.vue?vue&type=template&id=c627713e"
import script from "./Exercises.vue?vue&type=script&lang=js"
export * from "./Exercises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports